// extracted by mini-css-extract-plugin
module.exports = {"s1srlfg5":"s1srlfg5"};